import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { CustomersServices } from '../../../customers/services';
import { ConfigurationServices } from '../../../configuration/services';
import { TakeawayServices } from '../../services';
import { TakeawayOrderPage } from '../../takeaway-order/takeaway-order';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationDeliveriesCreatePage } from '../../../configuration/configuration-deliveries/configuration-deliveries-create/configuration-deliveries-create';
import { SearchServices } from '../../../services/searchs';
import { TakeawayDeliveryFavoritesPage } from '../../takeaway-delivery-favorites/takeaway-delivery-favorites';

/**
 * Pantalla para crear un nuevo plato o update de uno existente
 * En el params recibimos si es un plato existente o uno nuevo. En caso de ser
 * UPDATE tenenmos que rellenar los campos del formulario
 */

@Component({
  selector: 'page-takeaway-create-select-customer',
  templateUrl: 'takeaway-create-select-customer.html',
})
export class TakeawayCreateSelectCustomerPage {
  update_state: boolean = false;
  deliveryId: string;
  p_uid: any;
  p_name: any;
  uid_table: any;

  customers: any;
  customer_search: any;
  customer_data: any;
  show_list: boolean = false;

  show_date = true;
  date: any;
  dateTk: any;
  timeTk: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    private toastCtrl: ToastController,
    public customersServices: CustomersServices,
    public takeawayServices: TakeawayServices,
    public configurationServices: ConfigurationServices,
    public translate: TranslateService,
    public searchServices: SearchServices) {

    /*
  this.config.notFoundText = this.translate.instant('takeaway-create-select-customer-cliente-no-encontrado');
  this.config.placeholder = '...';
  this.config.loadingText = this.translate.instant('instant-loading') + '...';*/
    //Params
    this.update_state = this.navParams.get('update_state');
    this.uid_table = this.navParams.get('uid_table');
    //
    if (this.update_state) {
      this.checkCustomer();
    }

    //
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();

    //Ordenamos array de deliveries
    this.takeawayServices.deliveries.sort((a, b) => (a.name < b.name ? -1 : 1));

    this.customersServices.getListCustomers(this.globals.restaurant_uid);
    this.dateTk = new Date().toISOString().slice(0, 10);

    //en caso update insertar el delivery que ya tenia.
    if (this.update_state) {
      this.setDeliveryData();
      this.setDate();
    }
    //dismiss
    loadingPopup.dismiss();

    this.date = new Date().toISOString().slice(0, 10);
  }

  ionViewWillEnter() {
    this.configurationServices.recoveryDeliveriesFavorites();
  }

  async checkCustomer() {
    await this.takeawayServices.getIndexByTableuid();
    this.takeawayServices.selectedPersonId = this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].customer_uid;
    //
    this.searchServices.selectedPersonId =this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].customer_uid;
    this.searchServices.customer_data =this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].customer_name;
  }


  //update
  async setDeliveryData() {
    await this.takeawayServices.getIndexByTableuid();
    this.deliveryId = this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.delivery;
  }

  async insert() {
    if (this.checkValidCustomer() && this.checkValidDelivery()) {
      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: ''
      });
      loadingPopup.present();


      var cashs = await this.configurationServices.getCashFirst(this.globals.restaurant_uid);
      var _cash = cashs[0]; //Por defecto ponemos la primera caja
      //Recuperamos la caja activa
      if (!this.globals.checkLimitsByLicense('config', 'multi_cash')) {//Si tiene limite de cajas, cogemos una caja activa
        cashs.forEach(cash => {
          if (cash._active) {
            _cash = cash;
          }
        });
      } else { //Si no tiene limite de cajas, cogemos la primera caja recuperada
        _cash = cashs[0];
      }

      var customer = await this.customersServices.getCustomer(this.takeawayServices.selectedPersonId);
      this.takeawayServices.getCustomer(this.takeawayServices.selectedPersonId);


      var datetime_pickup_delivey;
      var new_date = new Date(this.dateTk);


      if (this.timeTk == undefined || this.dateTk == undefined) {
        this.show_date = false;
      }

      if (this.show_date) {
        datetime_pickup_delivey = new Date(new_date.getFullYear(), new_date.getMonth(), new_date.getDate(), this.timeTk.split(":", 1).pop(), this.timeTk.split(":").pop(), 0);
      } else {
        datetime_pickup_delivey = new Date();
      };

      await this.takeawayServices.afs.collection('tables').add({
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'cash_static': _cash.name,
        'cash_uid': _cash.UID,
        'name': '',
        'persons': '',
        'size': 2,
        'state': 'open',
        'ticket': {
          'amount': 0,
          'number': '',
          'payment': false,
          'payment_type': '',
          'list': {},
          'date': new Date(),
          'waiter_uid': this.globals.waiter_uid,
          'waiter': this.globals.waiter,
          'delivery': this.deliveryId,
          'created_at': new Date(),
          'updated_at': new Date(),
          'order_state': 'stateless',
          'tip': 0
        },
        'type': 'takeaway',
        'uid_room': '',
        'customer_name': customer.name,
        'customer_address': customer.address,
        'customer_phone': customer.phone,
        'customer_email': customer.email,
        'customer_uid': customer.UID,
        'created_at': new Date(),
        'updated_at': new Date(),
        'notes': customer.note,
        'datetime_pickup_delivey': datetime_pickup_delivey,
        'order_state': 'stateless',

      }).then(async doc => {
        this.globals.GAtrackView('TakeAway', 'TakeAway - Create', this.globals.restaurant.email, 'Create/Update', 'Create takeaway', 'TakeAway', '');
        //data set waiter activity
        var extra_activity: any =
        {
          'type': 'add',
          'value': 1,
          'source': 'takeaway',

        };
        this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
        //Get the UID Document
        var table = await this.takeawayServices.getTable(doc.id);
        this.takeawayServices.selected_table_tpv = table;
        //
        this.takeawayServices.selected_table_uid = doc.id;

        this.takeawayServices.selected_table_tpv_index = 0;
        this.takeawayServices.selected_type = 'takeaway';
        this.takeawayServices.quick_create = true;
        //Vaciamos el buscador de clientes
        this.searchServices.customer_data = '';
        this.takeawayServices.selectedPersonId = null;
        loadingPopup.dismiss();
        this.navCtrl.push(TakeawayOrderPage);


      });



    }
  }

  async update() {

    if (this.checkValidCustomer() && this.checkValidDelivery()) {
      var customer = await this.customersServices.getCustomer(this.takeawayServices.selectedPersonId);
      this.takeawayServices.getCustomer(this.takeawayServices.selectedPersonId);



      var new_date = new Date(this.dateTk);
      var datetime_pickup_delivey;

      if (this.timeTk == undefined || this.dateTk == undefined) {
        this.show_date = false;
      }

      if (this.show_date) {
        datetime_pickup_delivey = new Date(new_date.getFullYear(), new_date.getMonth(), new_date.getDate(), this.timeTk.split(":", 1).pop(), this.timeTk.split(":").pop(), 0);
      } else {
        datetime_pickup_delivey = new Date();
      }
      //getIndexByTableuid
      await this.takeawayServices.getIndexByTableuid();
      //set delivery
      this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.delivery = this.deliveryId;
      //getIndexByTableuid
      await this.takeawayServices.getIndexByTableuid();

      //update
      this.takeawayServices.afs.collection('tables').doc(this.uid_table).update({
        'customer_name': customer.name,
        'customer_address': customer.address,
        'customer_uid': customer.UID,
        'customer_email': customer.email,
        'customer_phone': customer.phone,
        'ticket': this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket,
        'datetime_pickup_delivey': datetime_pickup_delivey
      }).then(async doc => {
        this.globals.GAtrackView('TakeAway', 'TakeAway - Update', this.globals.restaurant.email, 'Create/Update', 'Update takeaway', 'TakeAway', '');
        //Get the UID Document
        this.navCtrl.pop();
        //Vaciamos el buscador de clientes
        this.searchServices.customer_data = '';
        this.takeawayServices.selectedPersonId = null;

      });

    }

  }

  openCreateDelivery() {
    this.navCtrl.push(ConfigurationDeliveriesCreatePage);
  }

  checkValidCustomer() {
    let _return = false;
    if (this.takeawayServices.selectedPersonId == null || this.takeawayServices.selectedPersonId == undefined) {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-cliente'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
      _return = false;
    } else {
      _return = true;
    }

    return _return;
  }

  checkValidDelivery() {
    let _return = false;
    if (this.deliveryId == null || this.deliveryId == undefined) {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('configuracion-introduce-nombre-delivery'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
      _return = false;
    } else {
      _return = true;
    }

    return _return;
  }

  getDeliveryImage(_delivery) {
    if (_delivery != undefined) {
      const delivery = this.takeawayServices.deliveries.find(t => t.name == _delivery);
      if (delivery != undefined) {
        return delivery.img;
      }
    }
  }

  changeDelivery(_delivery) {
    this.deliveryId = _delivery;
  }

  async setDate() {

    await this.takeawayServices.getIndexByTableuid();
    if ((undefined && this.timeTk != undefined && this.dateTk != undefined) || (this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].datetime_pickup_delivey)) {
      var _date = new Date(this.globals.timestampToDate(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].datetime_pickup_delivey));
      this.dateTk = new Date(_date).toISOString().slice(0, 10);
      this.timeTk = _date.getHours() + ":" + _date.getMinutes();
      this.show_date = true;
    }
  }

  editFavorites() {
    this.navCtrl.push(TakeawayDeliveryFavoritesPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-create/takeaway-create-select-customer/takeaway-create-select-customer.ts